import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getUserTemplates} from 'src/openapi/admin/apis/UserSearchTemplateApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useGetSearchTemplates = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getUserTemplates({userId}, {signal}),
    ), [userId, apiDispatch]);

    return useReadOnlyDataHook({initValue: [], getDispatchAction});
};
